<!-- event Head -->
<div class="loader_session" *ngIf='loaderdata'>
  <div class="loader-4"><span></span>
</div>
</div>

<div
  class="event-header"
  style="background-image: url(assets/image/Slider-Image-event.jpg)"
>
  <div class="event-heading">
    <div class="event-head">
      <h3>EVENTS</h3>
    </div>
  </div>
</div>
<!-- event items -->
<div class="events-items">
  <div class="container">
    <div class="row">
      <ng-template [ngIf]="eventspage == 'past' ">
        <div class="col-md-3 offset-md-3">
       
          <a routerLink="/event/past/1" class="events-member active"> Past Events </a>
     
        </div>
       
        <div class="col-md-3">
        
          <a routerLink="/event/future/1" class="events-member"> Future Events </a>
  
          
        </div>
      </ng-template>
        <ng-template [ngIf]="eventspage == 'future' ">
          <div class="col-md-3 offset-md-3">
       
            <a routerLink="/event/past/1" class="events-member "> Past Events </a>
       
          </div>
         
          <div class="col-md-3">
          
            <a routerLink="/event/future/1" class="events-member active"> Future Events </a>
    
            
          </div>
          </ng-template>
    </div>
  </div>
</div>
<!-- display Events -->
<div class="event-dispaly">
  <div class="event-display-heading">
    <ng-template [ngIf]="eventspage == 'past' ">
      <h2>PAST EVENTS</h2>
      </ng-template>
    <ng-template [ngIf]="eventspage == 'future' ">
    <h2>FUTURE EVENTS</h2>
    </ng-template>
  </div>
  <div class="container">
    <div class="event-details-item">
      <div class="row">
        <div class="col-12">
          <div class="event-display-img">
            <img
              src="{{data[0]?.event_image}}"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <div class="col-12 mt-5">
          <div class="display-event-items">
            <div class="listevent-display">
              <div class="detail-event-notify">
                <div class="calander-icon">
                  <div
                    class="cal-head"
                    style="
                      background-image: url(assets/image/icons/calander-icon.png);
                    "
                  >
                    <h2>{{data[0]?.notifydate[1]}}</h2>
                  </div>
                  <div class="cal-date">
                    <h4>{{data[0]?.notifydate[2]}}</h4>
                    <p>{{data[0]?.notifydate[0]}}</p>
                  </div>
                </div>
              </div>
              <div class="detail-event">
                <h4>{{data[0]?.event_head}}</h4>
                <span class="head">Where</span>
                <p>{{data[0]?.event_address}}</p>
                <span class="head">When</span>
                <p>{{data[0]?.event_timedate}}</p>
                <span class="head">About the Event</span>
                <div [innerHTML]="eventdetails"></div>
              </div>
            </div>
            <div class="view-item-details clear">
              <a   [routerLink]="['/event/',eventspage,1]"  class="viewMore">Back to Events</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="event-pagination">
    <div class="container">
      <div class="pagination-items">
        <div class="elements">
          <a href="#" class="pag-btn">
            <i class="fa fa-angle-double-left" aria-hidden="true"></i>
          </a>
          <a href="#" class="pag-btn">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
          </a>
          <span>
            <a href="#" class="pag-item-previous"> PREVIOUS</a>
            <a href="#" class="pag-item-next"> NEXT </a>
          </span>
          <a href="#" class="pag-btn">
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </a>
          <a href="#" class="pag-btn">
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>
  </div> -->
</div>

<app-contactform></app-contactform>